/* Keep the photographed garment color separate from a neutral cotton weave. */
(() => {
 const script=document.currentScript, selector='.card-swatch:not(.is-unmapped),.quick-add-swatch,.pdp-swatch:not(.is-unmapped),.surprise-option-swatch,.cp-filter-value > .rounded-full:not(.is-unmapped)';
 let colors={}, colorParser;
 const key=value=>String(value||'').trim().toLowerCase().replace(/[\s_]+/g,'-');
 // A separate display color improves tiny holiday shapes without changing the garment sample.
 function holidayColor(value) {
  if(!/^#|^rgba?\(/i.test(String(value).trim())) {
   colorParser ||= document.createElement('canvas').getContext('2d');
   if(!colorParser) return null;
   colorParser.fillStyle='#000001';colorParser.fillStyle=value;
   value=colorParser.fillStyle;
   if(value==='#000001') return null;
  }
  const hex=String(value).trim().match(/^#([\da-f]{3}|[\da-f]{6})$/i);
  const rgb=String(value).match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i);
  let channels;
  if(hex) { const full=hex[1].length===3?hex[1].split('').map(c=>c+c).join(''):hex[1];channels=full.match(/../g).map(c=>parseInt(c,16)/255); }
  else if(rgb) channels=rgb.slice(1,4).map(c=>Number(c)/255);
  else return null;
  const [r,g,b]=channels, max=Math.max(...channels), min=Math.min(...channels), delta=max-min, light=(max+min)/2;
  let hue=0, saturation=delta?delta/(1-Math.abs(2*light-1)):0;
  if(delta) hue=60*(max===r?((g-b)/delta+6)%6:max===g?(b-r)/delta+2:(r-g)/delta+4);
  // Keep neutral fabrics neutral; lift dark colors and add definition to pale colors.
  const neutral=delta<.04;
  saturation=neutral?saturation:Math.min(.8,Math.max(.5,saturation*1.4));
  const vividLight=neutral?Math.min(.88,light+.04):Math.min(.78,Math.max(.36,light+.07));
  return `hsl(${hue.toFixed(1)} ${(saturation*100).toFixed(1)}% ${(vividLight*100).toFixed(1)}%)`;
 }
 function apply(el) {
  const color=el.dataset.color||el.dataset.value||el.dataset.optionValue||el.closest('.surprise-option-choice')?.querySelector('input')?.value||el.closest('.cp-filter-value')?.dataset.value;
  let handle=el.dataset.swatchHandle||el.closest('surprise-picker')?.dataset.productHandle;
  if (!handle && el.dataset.productUrl) handle=el.dataset.productUrl.split('/products/')[1]?.split(/[.?]/)[0];
  if (!handle && el.classList.contains('pdp-swatch')) handle=location.pathname.split('/products/')[1]?.split('/')[0];
  const hex=key(color)==='white'?'#fafafa':colors[handle]?.[key(color)];
  if (hex) {
   if (el.classList.contains('pdp-swatch')) el.style.setProperty('--swatch-hex',hex);
   else if (el.classList.contains('surprise-option-swatch')) el.style.setProperty('--swatch',hex);
   else el.style.backgroundColor=hex;
  }
  // Keep the real garment color available when a holiday moves the paint into a shaped face.
  if (el.style.backgroundColor) el.style.setProperty('--swatch-fill',el.style.backgroundColor);
  const source=hex||el.style.getPropertyValue('--swatch-hex')||el.style.getPropertyValue('--swatch')||el.style.backgroundColor;
  const vivid=source&&key(color)!=='black'&&key(color)!=='white'?holidayColor(source):null;
  el.classList.toggle('has-holiday-color',!!vivid);
  if(vivid) el.style.setProperty('--holiday-swatch-fill',vivid);
  else el.style.removeProperty('--holiday-swatch-fill');
  el.classList.toggle('is-white-fabric',key(color)==='white');
  if (!el.classList.contains('swatch-textured')) {
   el.classList.add('swatch-textured');
   const weave=document.createElement('span');weave.className='cotton-weave';weave.setAttribute('aria-hidden','true');el.append(weave);
  }
 }
 function scan(root=document) { if(root.nodeType!==1&&root!==document)return; if(root.matches?.(selector))apply(root);root.querySelectorAll(selector).forEach(apply); }
 scan();
 new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(scan))).observe(document.body,{childList:true,subtree:true});
 if(script?.dataset.colors) fetch(script.dataset.colors).then(r=>{if(!r.ok)throw Error();return r.json();}).then(data=>{colors=data;scan();}).catch(()=>{});
})();
